// extracted by mini-css-extract-plugin
export default {"editorContainer":"textEditor_editorContainer__L+7+v"};